import React from "react";
import { motion } from "framer-motion";
import { formatNumber, formatFull } from "@/lib/format";
import { TrendUpIcon, TrendDownIcon, MinusIcon } from "@phosphor-icons/react";

const StatCard = ({ label, value, icon: Icon, accent = "#16C784", index = 0, sub, delta, deltaLabel }) => {
  const key = label.toLowerCase().replace(/\s+/g, "-");
  const hasDelta = delta !== null && delta !== undefined;
  const dir = !hasDelta ? null : delta > 0 ? "up" : delta < 0 ? "down" : "flat";
  const dirColor = dir === "up" ? "#16C784" : dir === "down" ? "#FF4D4D" : dir === "flat" ? "#FFB800" : "#FFFFFF";
  const DirIcon = dir === "up" ? TrendUpIcon : dir === "down" ? TrendDownIcon : MinusIcon;

  return (
    <motion.div
      data-testid={`stat-card-${key}`}
      initial={{ opacity: 0, scale: 0.98 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ delay: index * 0.08, duration: 0.4 }}
      className="relative bg-[#0C0C0E] border border-[#222226] p-5 hover:border-[#16C784]/50 transition-colors duration-300 overflow-hidden"
      style={{ boxShadow: "inset 0 1px 0 rgba(255,255,255,0.05)" }}
    >
      <div className="absolute top-0 left-0 w-full h-[2px]" style={{ background: hasDelta ? dirColor : accent, opacity: 0.6 }} />
      <div className="flex items-start justify-between">
        <div>
          <div className="text-[11px] font-bold uppercase tracking-[0.2em] text-[#A0A0AB]">{label}</div>
          <div
            data-testid={`stat-value-${key}`}
            className="font-rajdhani font-bold text-3xl md:text-4xl mt-2 transition-colors duration-300"
            style={{ color: hasDelta ? dirColor : "#FFFFFF" }}
            title={formatFull(value)}
          >
            {formatNumber(value)}
          </div>
          {hasDelta && (
            <div
              data-testid={`stat-delta-${key}`}
              className="flex items-center gap-1 mt-1.5 font-mono text-[11px]"
              style={{ color: dirColor }}
              title={deltaLabel ? `Change ${deltaLabel}` : "Change since last update"}
            >
              <DirIcon size={13} weight="bold" />
              {dir === "flat" ? "No change" : `${delta > 0 ? "+" : "−"}${formatNumber(Math.abs(delta))}`}
              <span className="text-[#5a5a63] ml-0.5">{deltaLabel || "· 24h"}</span>
            </div>
          )}
          {sub && <div className="font-mono text-[11px] text-[#5a5a63] mt-1">{sub}</div>}
        </div>
        <div
          className="w-10 h-10 rounded-full flex items-center justify-center border shrink-0"
          style={{ borderColor: (hasDelta ? dirColor : accent) + "66" }}
        >
          <Icon size={20} style={{ color: hasDelta ? dirColor : accent }} weight="fill" />
        </div>
      </div>
    </motion.div>
  );
};

export default StatCard;
